import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import constants from './constants';

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();});
};

class StateModule {
    constructor(){
      this.authed = localStorage.getItem('authed') || sessionStorage.getItem('authed');
      this.whiteList = JSON.parse(localStorage.getItem('whiteList') || sessionStorage.getItem('whiteList') || "[]");
      this.userID = localStorage.getItem('userID') || sessionStorage.getItem('userID') || "";
      this.userType = localStorage.getItem('userType') || sessionStorage.getItem('userType') || "";
      this.userName = localStorage.getItem('userName') || sessionStorage.getItem('userName') || constants.userNames[this.userID] || "Skyway Sales";
      // Set from the users doc in App.js. canDeleteLead (leadDelete.js) reads it to
      // match isAdmin() in firestore.rules.
      this.archived = false;
      this.mechanicId = localStorage.getItem('mechanicId') || sessionStorage.getItem('mechanicId') || "";
      this.mechanicName = localStorage.getItem('mechanicName') || sessionStorage.getItem('mechanicName') || "";
      // Which vendor a vendor account belongs to. Read here, synchronously, because
      // VendorDashboard picks its vendor in a useState initializer on the first
      // render — waiting for the users snapshot listener meant `vendor` was still
      // undefined and it fell back to the first vendor in the list (Superior),
      // showing every vendor Superior's data.
      this.vendor = localStorage.getItem('vendor') || sessionStorage.getItem('vendor') || "";
      this.selectedSOs = [];
      this.orgID = "skyway-classics";
    }

    secondaryAction = (input) => null;
    updatePlaid = () => null;

    states = [
        { name: 'ALABAMA', abbreviation: 'AL'},
        { name: 'ALASKA', abbreviation: 'AK'},
        { name: 'AMERICAN SAMOA', abbreviation: 'AS'},
        { name: 'ARIZONA', abbreviation: 'AZ'},
        { name: 'ARKANSAS', abbreviation: 'AR'},
        { name: 'CALIFORNIA', abbreviation: 'CA'},
        { name: 'COLORADO', abbreviation: 'CO'},
        { name: 'CONNECTICUT', abbreviation: 'CT'},
        { name: 'DELAWARE', abbreviation: 'DE'},
        { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
        { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM'},
        { name: 'FLORIDA', abbreviation: 'FL'},
        { name: 'GEORGIA', abbreviation: 'GA'},
        { name: 'GUAM', abbreviation: 'GU'},
        { name: 'HAWAII', abbreviation: 'HI'},
        { name: 'IDAHO', abbreviation: 'ID'},
        { name: 'ILLINOIS', abbreviation: 'IL'},
        { name: 'INDIANA', abbreviation: 'IN'},
        { name: 'IOWA', abbreviation: 'IA'},
        { name: 'KANSAS', abbreviation: 'KS'},
        { name: 'KENTUCKY', abbreviation: 'KY'},
        { name: 'LOUISIANA', abbreviation: 'LA'},
        { name: 'MAINE', abbreviation: 'ME'},
        { name: 'MARSHALL ISLANDS', abbreviation: 'MH'},
        { name: 'MARYLAND', abbreviation: 'MD'},
        { name: 'MASSACHUSETTS', abbreviation: 'MA'},
        { name: 'MICHIGAN', abbreviation: 'MI'},
        { name: 'MINNESOTA', abbreviation: 'MN'},
        { name: 'MISSISSIPPI', abbreviation: 'MS'},
        { name: 'MISSOURI', abbreviation: 'MO'},
        { name: 'MONTANA', abbreviation: 'MT'},
        { name: 'NEBRASKA', abbreviation: 'NE'},
        { name: 'NEVADA', abbreviation: 'NV'},
        { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
        { name: 'NEW JERSEY', abbreviation: 'NJ'},
        { name: 'NEW MEXICO', abbreviation: 'NM'},
        { name: 'NEW YORK', abbreviation: 'NY'},
        { name: 'NORTH CAROLINA', abbreviation: 'NC'},
        { name: 'NORTH DAKOTA', abbreviation: 'ND'},
        { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP'},
        { name: 'OHIO', abbreviation: 'OH'},
        { name: 'OKLAHOMA', abbreviation: 'OK'},
        { name: 'OREGON', abbreviation: 'OR'},
        { name: 'PALAU', abbreviation: 'PW'},
        { name: 'PENNSYLVANIA', abbreviation: 'PA'},
        { name: 'PUERTO RICO', abbreviation: 'PR'},
        { name: 'RHODE ISLAND', abbreviation: 'RI'},
        { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
        { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
        { name: 'TENNESSEE', abbreviation: 'TN'},
        { name: 'TEXAS', abbreviation: 'TX'},
        { name: 'UTAH', abbreviation: 'UT'},
        { name: 'VERMONT', abbreviation: 'VT'},
        { name: 'VIRGIN ISLANDS', abbreviation: 'VI'},
        { name: 'VIRGINIA', abbreviation: 'VA'},
        { name: 'WASHINGTON', abbreviation: 'WA'},
        { name: 'WEST VIRGINIA', abbreviation: 'WV'},
        { name: 'WISCONSIN', abbreviation: 'WI'},
        { name: 'WYOMING', abbreviation: 'WY' }
    ].map(x => ({value: x.abbreviation, label: x.name.toProperCase()}));

    sexes = [
        {value:"male", label: "Male"}, 
        {value:"female", label: "Female"},
        {value:"c", label: "Company"}
    ];

    _baseBanks = [
        {
            id: "workers",
            name: "Workers Federal Credit Union",
            address: "119 Russell St",
            city: "Littleton",
            state: "MA",
            zip: "01460",
            lien_id: "0204108393",
            is_elt: true,
        },

        {
          id: "greenwood",
          name: "Greenwood Credit Union",
          address: "2669 Post Road",
          city: "Warwick",
          state: "RI",
          zip: "02886",
          lien_id: "03885706",
          is_elt: true,
        },

        {
          id: "jjbest",
          name: "JJ Best Banc & Co.",
          address: "60 N Water St",
          city: "New Bedford",
          state: "MA",
          zip: "02740",
          lien_id: "228381777",
          is_elt: true,
        },

        {
          id: "fcu",
          name: "Floridacentral Credit Union",
          address: "3333 Henderson Blvd",
          city: " Tampa",
          state: "FL",
          zip: "33611",
          lien_id: "01883301",
          is_elt: true,
        },

        {
          id: "woodside",
          name: "Woodside Credit LLC",
          address: "PO BOX 12379",
          city: "Newport Beach",
          state: "CA",
          zip: "92658",
          lien_id: "231740745",
          is_elt: true,
        },

        {
          id: "usaa",
          name: "USAA Federal Savings Bank",
          address: "PO Box 318",
          city: "Wilmington",
          state: "OH",
          zip: "45177",
          lien_id: "201882743",
          is_elt: true,
        },

        {
          id: "power",
          name: "Power Financial Credit Union",
          address: "2020 N.W. 150th Avenue, Suite #100",
          city: "Pembroke Pines",
          state: "FL",
          zip: "33028",
          lien_id: "204850720",
          is_elt: true,
        },

        {
          id: "boul",
          name: "Boulevard Specialty Lending",
          address: "PO Box 440249",
          city: "St. Louis",
          state: "MO",
          zip: "63144",
          lien_id: "0245547173",
          is_elt: true,
        },

        {
          id: "medallion",
          name: "Medallion Bank",
          address: "1100 E 6600 S Suite 510",
          city: "Salt Lake City",
          state: "UT",
          zip: "84121",
          lien_id: "225208027",
          is_elt: true,
        },
    ];

    // The credit-app lender list shown in selectors. Built from _baseBanks and
    // enriched at runtime with per-lender config (email, ccEmails, invoiceFormat,
    // active) loaded from the Firestore `lenders` collection via applyLenderConfig.
    // NOTE: lenders are NOT the same as the Firestore `banks` collection, which
    // holds Skyway's own payment accounts (checks/wires).
    banks = this._baseBanks
        .slice()
        .sort((a,b) => (a.name > b.name) ? 1 : -1)
        .map((x,i) => ({value: "banks-"+i, label: x.name, data:x}));

    applyLenderConfig = (lenderDocs = []) => {
        const byId = {};
        (lenderDocs || []).forEach(l => { if (l && l.id) byId[l.id] = l; });
        this.banks = this._baseBanks
            .map(b => ({ ...b, ...(byId[b.id] || {}) }))
            .filter(b => b.active !== false)
            .sort((a,b) => (a.name > b.name) ? 1 : -1)
            .map((x,i) => ({value: "banks-"+i, label: x.name, data:x}));
    };

    fuels = [
        {value:"gas", label:"Gas"},
        {value:"diesel", label:"Diesel"},
        {value:"electric", label:"Electric"},
    ];
    
    app_types = [
        {value: "original", label: "Original"},
        {value: "transfer", label: "Transfer"},
    ];

    authed_emails = [
      "alan@skywayclassics.com",
      "augustin@skywayclassics.com",
      "bobby.chestnut@skywayclassics.com",
      "mark@skywayclassics.com",
      "max@skywayclassics.com",
      "mechanics@skywayclassics.com",
      "roger.hruby@skywayclassics.com",
      "roy.coleman@skywayclassics.com",
      "ryan@skywayclassics.com",
      "shane@skywayclassics.com",
      "david@skywayclassics.com",
      "porters@skywayclassics.com",
      "parts@skywayclassics.com"
    ];

    deposit_banks = [
      {value: "mercury", label: 'Mercury'}, 
      {value: "pilot", label: 'Pilot'},
      {value: "safe", label: 'Safe'}, 
      {value: "inventory", label: 'Trade'},
      {value: "wells-fargo", label: 'Wells Fargo'},
      {value: "seacoast", label: 'Seacoast'},
    ].sort((a,b) => (a.value > b.value) ? 1 : -1);


    isUserAllowed = (path) => {
      if(!this.whiteList) this.whiteList = [];
      const isRestricted = true; //["accounting", "deal-dashboard", "checks"].includes(path);
      if(isRestricted) return this.whiteList.includes(path);
      else return true;
    }

    binaryIndicator = (isEnabled) => (
      isEnabled ? <CheckBox /> : <CheckBoxOutlineBlank />
    );

    formatTitle = raw => {
      raw = raw.split('-');
      raw = raw.join(' ');
      return raw.charAt(0).toUpperCase() + raw.slice(1);
    }

    uploadFile = async params => {
      const {storageRef, file} = params;
      if(!storageRef || !file) return false;
      await storageRef.put(file);
      return true;
    }

    isAdmin = () => {
      // return false
      return this.userType === "admin";
    }

    isManager = () => {
      // return false
      return ["admin", "manager"].includes(this.userType);
    }

    // May approve, edit, or reject mechanics' proposed hours. Managers always can;
    // anyone else needs the 'approve-hours' permission.
    canApproveHours = () => {
      return this.isManager() || (this.whiteList || []).includes('approve-hours');
    }

    // May add, edit, and mark subcontracts Pending/Complete. Back office, service,
    // and parts always can; anyone else needs the 'subcontracts' permission.
    canEditSubcontracts = () => {
      return this.isBackoffice() || ['service', 'parts'].includes(this.userType) || (this.whiteList || []).includes('subcontracts');
    }

    // May delete subcontracts. Role-only: the 'subcontracts' permission does not grant it.
    canDeleteSubcontracts = () => {
      return this.isBackoffice() || ['service', 'parts'].includes(this.userType);
    }

    isSales = () => {
      // return false
      return ["sales"].includes(this.type);
    }

    isBackoffice = () => {
      // return false
      return ["admin", "manager", "backoffice"].includes(this.userType);
    }

    isPorter = () => {
      // return false
      return ["admin", "porter"].includes(this.userType);
    }

    // A mechanic an admin has explicitly granted line-editing to (the "Edit &
    // delete non-completed lines" toggle on the Mechanics tab). The grant lives
    // on the mechanic's roster doc (mechanics/{id}.can_edit_lines), hydrated into
    // constants.mechanics at boot. Scoped to NON-completed lines only, and never
    // includes backoffice+ (they're covered by canEditServiceLine directly).
    isGrantedLineMechanic = (service) => {
      if (this.isBackoffice()) return false;
      if (!this.mechanicId) return false;
      const m = constants.mechanics.find(x => x.id === this.mechanicId);
      if (!m || !m.can_edit_lines) return false;
      return !!service && service.status !== 'complete';
    }

    // May the current user edit this service line (name/notes/tag) and delete it?
    // Backoffice+ can edit any line; a granted mechanic can edit non-completed
    // lines only. Hours stay locked behind the proposed-hours request flow and
    // status stays manager-only regardless.
    canEditServiceLine = (service) => {
      return this.isBackoffice() || this.isGrantedLineMechanic(service);
    }

    setMechanicState = (mechanicId, mechanicName) => {
      this.mechanicId = mechanicId;
      this.mechanicName = mechanicName;
      
      // Update both storage types
      localStorage.setItem('mechanicId', mechanicId);
      localStorage.setItem('mechanicName', mechanicName);
      sessionStorage.setItem('mechanicId', mechanicId);
      sessionStorage.setItem('mechanicName', mechanicName);
    }

    clearMechanicState = () => {
      this.mechanicId = "";
      this.mechanicName = "";

      // Clear from both storage types
      localStorage.removeItem('mechanicId');
      localStorage.removeItem('mechanicName');
      sessionStorage.removeItem('mechanicId');
      sessionStorage.removeItem('mechanicName');
    }

    syncPermissions = (whiteList, userType, userName) => {
      this.whiteList = whiteList;
      this.userType = userType;
      if (userName) this.userName = userName;

      // A mechanic's login uid IS their `mechanics` doc id (see createStaffLogin in
      // the backend), so a signed-in mechanic already tells us which mechanic they
      // are. Without this, mechanicId stays empty — it used to be set only by the
      // picker on the login-free kiosk pages — and MechanicOrdersPage shows
      // "No mechanic ID found. Please log in as a mechanic to view your orders."
      // Only for mechanics: an admin's picker choice must not be overwritten.
      if (userType === 'mechanic' && this.userID && this.mechanicId !== this.userID) {
        this.setMechanicState(this.userID, userName || this.userName || '');
      }
    }
}

export const StateManager = new StateModule();
